// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_fv-0";
export var optionCard = "_fv-1";